export default "__VITE_ASSET__Dvh$m60___"